/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Button from '@tds/core-button';
import { InputWrapper, DateWrapper } from './css';
import { Box, Text } from '../design/css';
import MultiSelect from './multiselect';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

const VULFilters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels
}) => {
  const {
    startDate,
    endDate,
    completedStartDate,
    completedEndDate,
    channelId,
    province,
    productId,
    status,
    submitter
  } = filterState;
  const {
    filterByChannel,
    filterByProvince,
    filterByProducts,
    filterByStatus,
    filterBySubmitter,
    filterByOpenedDates,
    filterByValidationDates,
    startDateLabel,
    endDateLabel,
    buttonApply,
    buttonReset,
    filtersDropdownTitle
  } = staticLabels;
  const { channels, products, statuses, submitters } = data;
  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));
  const productList =
    productId &&
    products.map(product => ({ label: product.text, value: product.value }));
  const statusList =
    statuses &&
    statuses.map(statusdata => ({
      label: statusdata.text,
      value: statusdata.value
    }));

  let multiSelectFilters = [
    {
      label: filterByProvince,
      name: 'province',
      options: [
        { label: 'Alberta', value: 'alberta' },
        { label: 'British Columbia', value: 'british_columbia' },
        { label: 'Manitoba', value: 'manitoba' },
        { label: 'New Brunswick', value: 'newBrunswick' },
        {
          label: 'Newfoundland and Labrador',
          value: 'newfoundlandAndLabrador'
        },
        { label: 'Northwest Territories', value: 'northwestTerritories' },
        { label: 'Nova Scotia', value: 'novaScotia' },
        { label: 'Nunavut', value: 'nunavut' },
        { label: 'Ontario', value: 'ontario' },
        { label: 'Prince Edward Island', value: 'princeEdwardIsland' },
        { label: 'Quebec', value: 'quebec' },
        { label: 'Saskatchewan', value: 'saskatchewan' },
        { label: 'Yukon', value: 'yukon' }
      ],
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    },
    {
      label: filterByProducts,
      name: 'productId',
      options: productList,
      value: productId
    },
    {
      label: filterByStatus,
      name: 'status',
      options: statusList,
      value: status
    },
    {
      label: filterBySubmitter,
      name: 'submitter',
      options: (submitters || []).map(op => ({
        value: op.id,
        label: `${op.firstName} ${op.lastName}`
      })),
      value: submitter
    }
  ];

  const getMultiSelectFilters = listOfFilters => {
    return listOfFilters.map(({ label, options, name, value }) => {
      return (
        <div className="col-md-4">
          <MultiSelect
            updateFilters={updateFilters}
            label={label}
            options={options}
            name={name}
            value={value}
          />
        </div>
      );
    });
  };

  const getDateFilters = () => {
    return (
      <>
        <div className="col-md-4">
          <Box
            style={{ paddingBottom: 6, paddingLeft: 0 }}
            className="col-md-12"
          >
            <Text>{filterByOpenedDates} </Text>
          </Box>
          <InputWrapper>
            <DateWrapper
              style={{ marginRight: '5px', paddingLeft: 0 }}
              className="col-md-6"
            >
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={startDateLabel}
                selected={startDate}
                onChange={value => updateFilters('startDate', value)}
              />
            </DateWrapper>
            <DateWrapper className="col-md-6">
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={endDateLabel}
                minDate={startDate}
                selected={endDate}
                onChange={value => updateFilters('endDate', value)}
              />
            </DateWrapper>
          </InputWrapper>
        </div>
        <div className="col-md-4">
          <Box
            style={{ paddingBottom: 6, paddingLeft: 0 }}
            className="col-md-12"
          >
            <Text>{filterByValidationDates} </Text>
          </Box>
          <InputWrapper>
            <DateWrapper
              style={{ marginRight: '5px', paddingLeft: 0 }}
              className="col-md-6"
            >
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={startDateLabel}
                selected={completedStartDate}
                onChange={value => updateFilters('completedStartDate', value)}
              />
            </DateWrapper>
            <DateWrapper className="col-md-6">
              <DatePicker
                dateFormat="yyyy/MM/dd"
                placeholderText={endDateLabel}
                minDate={completedStartDate}
                selected={completedEndDate}
                onChange={value => updateFilters('completedEndDate', value)}
              />
            </DateWrapper>
          </InputWrapper>
        </div>
      </>
    );
  };
  return (
    <ExpandCollapse topDivider={false}>
      <ExpandCollapse.Panel id="filters" header={filtersDropdownTitle}>
        <div className="row">
          {getDateFilters()}
          {getMultiSelectFilters(multiSelectFilters)}
        </div>

        <Box
          display="flex"
          justifyContent="center"
          flexDirection="row"
          pt={64}
          mdJustifyContent="flex-start"
          mdWidth={100}
          mdPadding="16px 0"
          margin="0 auto"
        >
          <Button onClick={onApplyFilters} variant="secondary">
            {buttonApply}
          </Button>
          <Box width="2"> </Box>
          <Button onClick={onResetFilters}>{buttonReset}</Button>
        </Box>
      </ExpandCollapse.Panel>
    </ExpandCollapse>
  );
};

export default VULFilters;

VULFilters.propTypes = {
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    filterStatus: PropTypes.string,
    startDate: PropTypes.dateFormat,
    endDate: PropTypes.dateFormat,
    completedStartDate: PropTypes.dateFormat,
    completedEndDate: PropTypes.dateFormat,
    submitter: PropTypes.array,
    status: PropTypes.array,
    channelId: PropTypes.array,
    province: PropTypes.array,
    productId: PropTypes.array
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
